import { PropsWithChildren } from 'react';
import { ErrorClass } from './class.tsx';

export function GlobalError({ children }: PropsWithChildren) {
  return <ErrorClass>{children}</ErrorClass>;
}
